/* eslint-disable ts/no-unsafe-assignment */
import Root from "./DropdownMenu.vue";
import Item from "./DropdownMenuItem.vue";

export const DropdownMenu = {
  Root,
  Item,
};
